// extracted by mini-css-extract-plugin
export default {"p":"bafa8260ed _68df911a46 d687e68084","clr":"_6106eb66c3","dls":"d3cd2af8fd"};